import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Loading } from "@/components/ds";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Filaments from "@/pages/Filaments";
import Stock from "@/pages/Stock";
import Plates from "@/pages/Plates";
import Products from "@/pages/Products";
import Orders from "@/pages/Orders";
import Settings from "@/pages/Settings";
import Calculator from "@/pages/Calculator";
import Catalog from "@/pages/Catalog";
import Production from "@/pages/Production";
import Partners from "@/pages/Partners";
import Finance from "@/pages/Finance";
import Reports from "@/pages/Reports";
import PartnerArea from "@/pages/PartnerArea";
import OrderTracking from "@/pages/OrderTracking";
import PublicPix from "@/pages/PublicPix";
import PartnerInterest from "@/pages/PartnerInterest";
import Development from "@/pages/Development";
import DevelopmentProject from "@/pages/DevelopmentProject";
import Notes from "@/pages/Notes";
import Customers from "@/pages/Customers";
import Creators from "@/pages/Creators";
import CreatorPanel from "@/pages/CreatorPanel";

function CreatorProtected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading label="Abrindo seu painel..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "creator") return <Navigate to="/" replace />;
  return children;
}

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading label="Abrindo o TR3ND OS..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "partner") return <Navigate to="/parceiro" replace />;
  if (user.role === "creator") return <Navigate to="/criadora" replace />;
  return children;
}

function PartnerProtected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading label="Abrindo sua área..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "partner") return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading label="Abrindo o TR3ND OS..." />;
  if (user) return <Navigate to={user.role === "partner" ? "/parceiro" : "/"} replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/catalogo/p/:slug" element={<Catalog />} />
          <Route path="/pedido/:token" element={<OrderTracking />} />
          <Route path="/pagar/:token" element={<PublicPix />} />
          <Route path="/sejaparceiro" element={<PartnerInterest />} />
          <Route
            path="/criadora"
            element={
              <CreatorProtected>
                <CreatorPanel />
              </CreatorProtected>
            }
          />
          <Route
            path="/parceiro"
            element={
              <PartnerProtected>
                <PartnerArea />
              </PartnerProtected>
            }
          />
          <Route
            path="/login"
            element={
              <PublicOnly>
                <Login />
              </PublicOnly>
            }
          />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/estoque" element={<Stock />} />
            <Route path="/plates" element={<Plates />} />
            <Route path="/produtos" element={<Products />} />
            <Route
              path="/producao"
              element={<Production />}
            />
            <Route
              path="/pedidos"
              element={<Orders />}
            />
            <Route path="/configuracoes" element={<Settings />} />
            <Route path="/mural" element={<Notes />} />
            <Route path="/clientes" element={<Customers />} />
            <Route path="/criadoras" element={<Creators />} />
            <Route path="/calculadora" element={<Calculator />} />
            <Route path="/desenvolvimento" element={<Development />} />
            <Route path="/desenvolvimento/:id" element={<DevelopmentProject />} />
            <Route
              path="/parceiros"
              element={<Partners />}
            />
            <Route path="/financeiro" element={<Finance />} />
            <Route path="/relatorios" element={<Reports />} />
          </Route>
          <Route path="/:creatorSlug" element={<Catalog />} />
          <Route path="/:creatorSlug/p/:slug" element={<Catalog />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
